import './index.less';

interface IProps {
  orderId?: string;
  account?: string;
  description?: string;
  duration?: string;
}

function maskPhone(phone: string, maskChar: string = '*', prefixLength: number = 3, suffixLength: number = 4): string {
  if (prefixLength + suffixLength > phone.length) {
    throw new Error('Invalid prefixLength or suffixLength');
  }
  const maskedSection = phone.slice(prefixLength, phone.length - suffixLength).replace(/./g, maskChar);
  return phone.slice(0, prefixLength) + maskedSection + phone.slice(phone.length - suffixLength);
}


enum PhoneVerifyStatus {
  Empty = 'empty',
  Invalid = 'invalid',
  Valid = 'valid',
}

const handlerVerifyPhone = (phone: string) => {
  if (!phone) {
    return PhoneVerifyStatus.Empty;
  }
  const reg = /^(1[3-9]\d{9})$/;
  if (reg.test(phone)) {
    return PhoneVerifyStatus.Valid;
  }
  return PhoneVerifyStatus.Invalid;
};

function maskAccount(account: string) {
  if (handlerVerifyPhone(account) === PhoneVerifyStatus.Valid) {
    return maskPhone(account);
  } else {
    return account;
  }
}

export default function PayInfos(props: IProps) {
  const { orderId, account, description, duration } = props;

  return (
    <div className="pay-info-container">
      <div className="pay-info-item">
        <span>订单编号</span>
        <span className="pay-info-item-value">{orderId}</span>
      </div>
      <div className="pay-info-item">
        <span>关联账号</span>
        <span className="pay-info-item-value">{maskAccount(account || '')}</span>
      </div>
      <div className="pay-info-item">
        <span>购买权益</span>
        <span className="pay-info-item-value">{description}</span>
      </div>
      <div className="pay-info-item">
        <span>权益时限</span>
        <span className="pay-info-item-value">{duration}</span>
      </div>
    </div>
  );
}
